// Все даты в интерфейсе показываем в американском стандарте:
// MM/DD/YYYY и 12-часовое время (независимо от локали браузера).

const US_DATE_OPTS = { month: '2-digit', day: '2-digit', year: 'numeric' };
const US_TIME_OPTS = { hour: '2-digit', minute: '2-digit' };

const toDate = (value) => {
  if (!value) return null;
  const d = value instanceof Date ? value : new Date(value);
  return Number.isNaN(d.getTime()) ? null : d;
};

// 07/15/2026
export function fmtDateUS(value, fallback = '—') {
  const d = toDate(value);
  return d ? d.toLocaleDateString('en-US', US_DATE_OPTS) : fallback;
}

// 07/15/2026, 03:45 PM
export function fmtDateTimeUS(value, fallback = '—') {
  const d = toDate(value);
  if (!d) return fallback;
  return `${d.toLocaleDateString('en-US', US_DATE_OPTS)}, ${d.toLocaleTimeString('en-US', US_TIME_OPTS)}`;
}
